import { Dialog as MuiDialog, DialogTitle, styled } from "@mui/material";
import { sizing } from "../../utils/methods";

type DialogProps = {
  open: boolean;
  onClose(): void;
  title?: string;
  titleAlign?: "center" | "left" | "right";
  children?: any;
  maxWidth?: boolean;
};

const Dialog = ({ maxWidth, open, onClose, title, children }: DialogProps) => {
  return (
    <_Dialog classes={{ container: maxWidth ? "maxWidthDialog" : "" }} open={open} onClose={() => onClose()}>
      {title && <DialogTitle sx={{ p: sizing(6), pb: sizing(0) }}>{title}</DialogTitle>}
      {children}
    </_Dialog>
  );
};

const _Dialog = styled(MuiDialog)`
  .maxWidthDialog .MuiDialog-paper {
    max-width: 1560px;
    margin: 0 auto;
  }
`;
export default Dialog;
